import React, { Component, Fragment } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import { Button, Form, FormGroup, Label, Input, FormText, Badge } from 'reactstrap';
import { SidePanel } from '../../common/SidePanel';
import { findObjectIndexInArray } from '../../utils/ArrayUtil';
import { TransitionComponents } from '../../common/TransitionComponents';
import { isNumber } from '../../utils/Validation';
import { PerkInProductAddEdit } from './PerkInProductAddEdit';

export class PerkInProducts extends Component {
    static displayName = PerkInProducts.name;

    constructor(props) {
        super(props);
        this.state = {
            designerId: props.designerId,
            perkId: props.perkId,
            data: props.data.products || [],
            loading: false,
            error: null,
            editObject: null,
            showSlide: false
        };

        this.populateProductList = this.populateProductList.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setError = this.setError.bind(this);
        this.showAddEditSlide = this.showAddEditSlide.bind(this);
        this.onSlideExited = this.onSlideExited.bind(this);
        this.updateData = this.updateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
    }

    componentDidMount() {
        this.populateProductList();
    }

    componentWillReceiveProps(props) {
        //this.setState({ data: props.data })
    }

    setError(error) {
        this.props.setError(error);
        this.setState({ loading: false });
    }

    showAddEditSlide(index) {
        //console.log('id: ' + index);
        this.setState({
            showSlide: true,
            editObject: isNumber(index) && index >= 0 ? {
                ...this.state.data[index],
                index: index
            } : null
        });
    }

    onSlideExited() {
        this.setState({
            showSlide: false,
            editObject: null
        });
    }

    updateData(obj) {
        console.log('saving:')
        console.log(obj)
        if (!obj) return;

        const uniName = this.state.productList[findObjectIndexInArray(this.state.productList, obj.productId, 'productId')].title;
        obj.title = uniName;

        if (isNumber(obj.index) && obj.index >= 0 && this.state.data.length > obj.index) {
            //edit
            this.setState({
                data: this.state.data.map((item, index) => {
                    if (obj.index === index) {
                        item.productId = obj.productId;
                        item.title = obj.title;
                        item.maxClaimInProduct = obj.maxClaimInProduct;
                    }
                    return item;
                })
            });
        } else {
            //add
            obj.totalClaim = 0;
            this.setState({
                data: [
                    ...this.state.data,
                    obj
                ]
            });
        }
    }

    deleteData(index) {
        if (isNumber(index) && index >= 0 && this.state.data.length > index) {
            console.log('deleting: ' + index);
            const arr = this.state.data;
            arr.splice(index, 1);
            this.setState({
                data: arr
            });
        }
    }


    render() {
        const { designerId, perkId, data, loading, editObject, showSlide } = this.state;

        let productItems = this.state.data.map((item, index) => {
            return (
                <tr key={index}>
                    <th scope="row">{item.title}</th>
                    <td className="text-center">{isNumber(item.maxClaimInProduct) ? item.maxClaimInProduct : '0'}</td>
                    <td className="text-center">{isNumber(item.totalClaimed) ? item.totalClaimed : '0'}</td>
                    <td className="text-center"></td>
                    <td className="d-flex flex-row justify-content-end">
                        <button type="button" className="btn btn-default btn-sm py-0 px-1 d-flex align-items-center" aria-label="Edit"
                            onClick={() => {
                                this.showAddEditSlide(index);
                            }}>
                            <svg height="16" viewBox="0 0 48 48" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M6 34.5v7.5h7.5l22.13-22.13-7.5-7.5-22.13 22.13zm35.41-20.41c.78-.78.78-2.05 0-2.83l-4.67-4.67c-.78-.78-2.05-.78-2.83 0l-3.66 3.66 7.5 7.5 3.66-3.66z" /><path d="M0 0h48v48h-48z" fill="none" /></svg>
                        </button>
                        <button type="button" className="btn btn-default btn-sm py-0 px-1 d-flex align-items-center" aria-label="Delete"
                            onClick={() => {
                                this.deleteData(index);
                            }}>
                            <svg height="16" viewBox="0 0 48 48" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M12 38c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-24h-24v24zm26-30h-7l-2-2h-10l-2 2h-7v4h28v-4z" /><path d="M0 0h48v48h-48z" fill="none" /></svg>
                        </button>
                    </td>
                </tr>
            );
        });

        //console.log(showSlide);
        return (
            <div>
                <h3>Products</h3>
                <div className="bg-white rounded box-shadow p-4 mb-4">
                    <div className="mb-1">Product list</div>
                    <FormText color="muted" className="text-left mb-3">
                        List of products linked to the perk
                    </FormText>

                    <Button color="dark" size="sm" className="mb-3" disabled={loading} onClick={() => this.showAddEditSlide()}>Link product</Button>

                    <div className="table-responsive">
                        <table className="table table-hover table-sm table-borderless table-striped">
                            <caption>List of products</caption>
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">Product</th>
                                    <th className="text-center" scope="col">Max claim allowed</th>
                                    <th className="text-center" scope="col">Total claimed</th>
                                    <th className="text-center" scope="col">Status</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {productItems}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-4 mb-5 formbox-savebtn">
                        <div className="row">
                            <div className="col-7"></div>
                            <div className="col-5 text-right">
                                <Button color="dark" size="sm" disabled={loading} onClick={() => this.handleSubmit()}>{!loading ? 'Save changes' : 'Loading..'}</Button>
                            </div>
                        </div>
                    </div>

                    <TransitionComponents className="slideanim"
                        show={loading === false && showSlide}>
                        <PerkInProductAddEdit
                            designerId={designerId}
                            perkId={perkId}
                            data={editObject}
                            existList={data}
                            onExited={this.onSlideExited}
                            productList={this.state.productList}
                            update={this.updateData}
                        />
                    </TransitionComponents>
                </div>
            </div>
        );
    }

    async handleSubmit() {
        this.setState({ loading: true });

        console.log('submitting..');
        console.log(this.state);

        const token = await authService.getAccessToken();
        if (!token) {
            this.setError(`Could not retrieve authentication`);
            return;
        }

        const reqHeader = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Authorization': `Bearer ${token}`
        };

        const { data } = this.state;

        const response = await fetch(`/api/brand/${this.state.designerId}/perks/details/${this.state.perkId}/edit/products`, {
            method: 'post',
            headers: reqHeader,
            body: JSON.stringify(data)
        });


        try {
            const newDta = await response.json();

            if (newDta && newDta.result) {
                //added
                console.log('Brand submitted');
                console.log(newDta);

                this.setState({ data: newDta.perkInProducts, loading: false });

                //this.props.scrollPageToTop();
                this.props.updateData(function () {
                    //update button state
                });
            } else {
                this.setError(`Error`);
            }
        } catch (e) {
            this.setError(`Error`);
            console.log(e);
        }
    }

    async populateProductList() {
        const token = await authService.getAccessToken();
        const response = await fetch(`/api/brand/${this.state.designerId}/store/products/live`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        console.log(data);
        this.setState({
            productList: data,
            loading: false
        });
    }
}
